/**
 * @deprecated because this doesn't check for arrays which are also of type 'object'.
 * Use `isObjectV2` instead.
 */
export function isObject<T = Record<string, unknown>>(obj: unknown): obj is Record<keyof T, unknown> {
  if (!obj) {
    return false;
  }
  return typeof obj === 'object';
}

export function isObjectV2<T = Record<string, unknown>>(obj: unknown): obj is Record<keyof T, unknown> {
  if (!obj) {
    return false;
  }
  return typeof obj === 'object' && !Array.isArray(obj);
}
